import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type NewDayPayload = {
  commanded_basal_rate?: number;
};

export type NewDayEvent = {
  commandedBasalRate?: number;
};

const newDaySchema = z.object({
  commanded_basal_rate: cz.permissive(z.number()),
});

export const LID_NEW_DAY = {
  value: 0x5a,
  name: "New Day Event",
  format: "f............",
  fields: ["commanded_basal_rate"],
  postprocess: rec => ({
    commandedBasalRate: rec.commanded_basal_rate,
  }),
  schema: newDaySchema,
} as const satisfies TandemEventDefinition<NewDayPayload, NewDayEvent>;
